"use client";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ROUTES, UI } from "@/constants";
import { IdType, UserType } from "@/types";
import { Heart } from "lucide-react";
import { LinkWithParams } from "./LinkWithParams";
import { memo } from "react";

type PrefsIconProps = {
  userId: IdType;
  orderId?: IdType;
  userName: UserType["name"];
  disable?: boolean;
  message?: string;
};

export const PrefsIcon = memo(({ userId, orderId, userName, disable, message }: PrefsIconProps) => {
  return (
    <Tooltip>
      <TooltipTrigger className={disable ? "pointer-events-none opacity-50" : ""}>
        <LinkWithParams
          href={
            orderId
              ? ROUTES.users.orderPreferences(userId, orderId)
              : ROUTES.users.userPreferences(userId)
          }
        >
          <Heart size={16} className="text-destructive hover:scale-110 transition-transform" />
        </LinkWithParams>
      </TooltipTrigger>
      <TooltipContent>
        {UI.titles.goTo} {UI.titles.userPreferencesTitle(userName)}{" "}
        {message && message}
      </TooltipContent>
    </Tooltip>
  );
});

PrefsIcon.displayName = "PrefsIcon";
